interface FacilityRelocateParams {
  companyname: string;
  is_public: boolean;
  장지시군구: string;
  계신지역: string;
  count: string;
  is_open_ready: string;
  compare_need: string;
  장지유형: string;
  facility_type: string;
}

export const questionTemplate = {
  /**
   * 화장 예약 빠른 도움 요청 스토리. v2: 헤더·전화번호·🚨·ops멘션은 BE가 부착 (postLeadV2).
   * 화장 예약 = 이미 임종하신 상태이므로 caller가 status="임종상태" 전달 → BE가 상담팀 멘션.
   */
  crematoriumReserve: (crematoriumName: string, sourcePath: string) =>
    `질문 내용 : *화장 예약 빠른 도움 요청*\n\n출처: ${sourcePath}\n대상 화장장: *${crematoriumName}*\n-----\n화장장 페이지에서 "화장장 예약 빠르게 도움받기"를 요청하신 고객님입니다.\n*화장장 예약 니즈가 있는 고객입니다. 상황 파악 후 화장 예약을 미끼로 장례 상담까지 이어가시기를 바랍니다.*`,

  /**
   * 장례 절차 문의 스토리. v2: 헤더·전화번호·🚨는 BE가 부착 (postLeadV2).
   * memo는 자유입력이라 status 확정 불가 → status 미전송(스펙 기준). memo는 스토리에 유지.
   * ⚠️ `*메모*` 문자열은 v2 BE가 400(status 예약어)로 쳐냄 → "준비 상황 :" 라벨 사용.
   */
  procedure: (selectedProcedure: string, memo: string) =>
    `질문 내용 : *장례 절차 문의*\n\n질문 상세 : ${selectedProcedure}\n-----\n견적 제출 시 절차에 대한 정보를 요청하신 고객님입니다. \n질문 상세 내용부터 해소한 후, 장례 전반에 대해 상담을 진행해주세요.\n⚠️ 프라임 가입 직후 제출된 경우 → 1트까지만 진행 가능`,

  /** 지역 장례식장 비교 견적 요청 스토리. v2: 헤더·전화번호·*메모*·🚨·야간줄은 BE/구조화 필드가 처리. */
  parlorCompare: (parlorName: string, regionLabel: string) =>
    `질문 내용 : *지역 장례식장 비교 견적 요청*\n\n기준 장례식장: *${parlorName}* (${regionLabel})\n-----\n장례식장 상세 페이지에서 "이 지역 장례식장 비교 견적"을 요청하신 고객님입니다.\n인근 장례식장들의 비용/시설을 궁금해할 가능성이 높습니다.`,

  /** 개장·이장 문의 스토리. v2: 헤더·전화번호·🚨는 BE가 부착 (postLeadV2). */
  facilityRelocate: (params: FacilityRelocateParams) =>
    `질문 내용 : *개장, 이장 문의 도착!*\n\n\n${params.companyname} 개장 이장 문의\n(${
      params.장지시군구
    }, *${
      params.is_public ? "공설" : "사설"
    })\n\n(장례지도사에게 전달 시 추가 메세지와 함께 절취선 하단을 복사해주세요)\n-----\n*${
      params.장지시군구
    }에 위치한 ${
      params.companyname
    }로 이장하시고자 문의주신 고객님입니다.*\n\n*[기본정보]*\n\n옮기고자 하시는 인원: ${
      params.count
    }\n개장 공사 준비: ${params.is_open_ready ? "이미 준비 하심" : "아직 준비하지 않음"}\n${
      params.companyname
    } 이외 장지 비교 요청: ${params.compare_need}\n${
      params.is_open_ready === "아니오"
        ? `\n*[현재 모시고 계신 곳]*\n\n지역: ${params.계신지역}\n\n모시고 계신 상태: ${params.장지유형}\n모시고 계시는 시설 종류: ${params.facility_type}\n-----`
        : ""
    }`,

  /**
   * 온드미디어 장례지도사 문의 스토리(온드미디어 유입). v2: 헤더·전화번호·🚨는 BE가 부착 (postLeadV2).
   * 문항이 임박도가 아니라 의도라 status 는 미전송. 선택값은 `궁금한 점:` 한 줄로만 들어간다.
   */
  funeralDirectorInquiry: (reason: string) =>
    `질문 내용 : *온드미디어 장례지도사 문의*\n\n궁금한 점: *${reason}*\n-----\n장례지도사에 대해 궁금한 점이 있어 상담을 요청하신 고객님입니다.\n유튜브나 인스타그램 콘텐츠를 확인하고 유입된 고객님입니다.`,

  /** 해양장 문의 스토리. v2: 헤더·전화번호·🚨는 BE가 부착 (postLeadV2). */
  seaBurialInquiry: (funeralHallName: string) =>
    `질문 내용 : *${funeralHallName} 문의*\n\n궁금한 점:\n-----\n${funeralHallName} 예상 비용과 절차를 함께 확인하고 싶어하는 고객님입니다.\n유튜브나 인스타그램 콘텐츠를 확인하고 유입된 고객님입니다.`,
};
